export class RegisterResponse {
  id: string;

  public getId() {
    return this.id;
  }
}
